<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Detalles Caso de Taller</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>

					<b-card-body>
						<b-row>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Número de Caso: </span> {{workshopIncident.Number}}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Sistema: </span>
									{{workshopIncident.System}}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha de Creación: </span>
									{{workshopIncident.CreatedOn|dateFormat}}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha de Retiro - Desinstalación: </span>
									{{workshopIncident.UninstallDate|dateFormat}}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha de Ingreso al Taller: </span>
									{{workshopIncident.AdmissionDate|dateFormat}}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha Límite: </span>
									{{workshopIncident.Deadline|dateFormat}}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Estado de Revisión: </span>
									{{workshopIncident.RevisionStatus}}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">En Revisión: </span>
									<i v-if="workshopIncident.OnRevision" class="fa fa-check-square-o"
									   aria-hidden="true"></i>
									<i v-else class="fa fa-times-circle" aria-hidden="true"></i>
								</h6>
							</b-col>
							<b-col md="12" lg="12">
								<h6><span class="text-info">Descripción: </span>
									{{workshopIncident.Title}}</h6>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Revisión</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>

					<b-card-body>
						<b-row>
							<b-col md="12" lg="12">
								<h6 class="border-bottom border-primary pb-1">Equipos para Reparación</h6>
								<div class="table-responsive">
									<b-table :items="workshopIncident.Products"
											 :fields="productTableFields"
											 :busy="loading"
											 show-empty
											 striped
											 empty-filtered-text="No hay equipos en reparación disponibles"
											 empty-text="No hay equipos en reparación disponibles"
											 head-variant="light">
										<div slot="AdmissionDate" slot-scope="item">
											{{item.item.AdmissionDate | dateFormat}}
										</div>
										<div slot="BillingDate" slot-scope="item">
											{{item.item.BillingDate | dateFormat}}
										</div>
										<div slot="IsRepaired" slot-scope="item">
											<i v-if="item.item.IsRepaired" class="fa fa-check-square-o"
											   aria-hidden="true"></i>
											<i v-else class="fa fa-times-circle" aria-hidden="true"></i>
										</div>
										<template v-slot:table-busy>
											<div class="text-center text-info my-2">
												<b-spinner class="align-middle"></b-spinner>
											</div>
										</template>
									</b-table>
								</div>
							</b-col>
							<b-col md="12" lg="12" class="mt-4">
								<h6 class="border-bottom border-primary pb-1">Datos de Revisión</h6>
								<h6><span class="text-info">Antecedentes: </span>
									{{workshopIncident.Records}}</h6>
								<div class="d-flex justify-content-start align-items-center">
									<h6><span class="text-info">En Garantía: </span>
										<i v-if="workshopIncident.InWarranty" class="fa fa-check-square-o"
										   aria-hidden="true"></i>
										<i v-else class="fa fa-times-circle" aria-hidden="true"></i>
									</h6>
									<h6 class="ml-3"><span class="text-info">Tiene Reparación: </span>
										<i v-if="workshopIncident.HasRepair" class="fa fa-check-square-o"
										   aria-hidden="true"></i>
										<i v-else class="fa fa-times-circle" aria-hidden="true"></i>
									</h6>
								</div>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";
	import {mapActions, mapState} from "vuex";

	export default {
		name: "WorkshopIncidentDetail",
		components: {
			AccountDetailComponent,
			GoBackComponent,
		},
		data: function () {
			return {
				loading: false,
				workshopIncident: '',
				currentPage: 1,
				perPage: 10,
				productTableFields: {
					AdmissionDate: {
						label: 'F.Ingreso Taller'
					},
					ProductInternal: {
						label: 'Equipo Vendido x SPC'
					},
					SerialNumberInternal: {
						label: '#Serie Equipo Vendido x SPC'
					},
					ProductExternal: {
						label: 'Producto no Vendido x SPC'
					},
					SerialNumberExternal: {
						label: '#Serie Producto no Vendido x SPC'
					},
					BillingDate: {
						label: 'F.Facturación'
					},
					IsRepaired: {
						label: 'Reparado'
					},
				}
			}
		},
		mounted() {
			if (this.$store.state.accountSelected !== '') {
				this.loading = true;

				const workshopIncidentId = this.$route.params.id;

				this.getWorkshopIncidentDetail(workshopIncidentId)
					.then((workshopIncident) => {
						console.log(workshopIncident);
						this.workshopIncident = workshopIncident;
					})
					.catch((err) => {
						console.log(err.response);
					})
					.finally(() => {
						this.loading = false;
					})

			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			...mapActions([
				'getWorkshopIncidentDetail',
			])
		},
		computed: {
			...mapState({
				accountSelected: state => state.accountSelected,
			})
		}
	}
</script>

<style scoped>

</style>
